export const getWagerLeftValueAndBonus = (currentWager: number, levels) => {
    let currentTierIndex = -1
    let nextTierStartUsd = 0
    let nextLevelWager = 0
    let nextBonus = 0

    for (let i = 0; i < levels.length; i++) {
      const level = levels[i]
      const startUsd = level.tierStartUsd
      const endUsd = startUsd + level.tierStep * (level.tierCount - 1)

      if (currentWager < startUsd) {
        // If the current wager is before this tier starts, calculate wager left to start of this tier
        nextTierStartUsd = startUsd
        nextBonus = level.bonusUsd[0] / 100 // Convert cents to dollars
        break
      }

      if (currentWager >= startUsd && currentWager <= endUsd) {
        // If the current wager is within this tier
        currentTierIndex = i
        const currentLevel = Math.floor((currentWager - startUsd) / level.tierStep)
        nextLevelWager = startUsd + (currentLevel + 1) * level.tierStep
        nextBonus = (level.bonusUsd[currentLevel + 1] || level.bonusUsd[level.bonusUsd.length - 1]) / 100 // Convert cents to dollars
        break
      }

      // Calculate the start of the next tier if the current wager is between tiers
      if (i < levels.length - 1) {
        const nextTierStart = levels[i + 1].tierStartUsd
        if (currentWager > endUsd && currentWager < nextTierStart) {
          nextTierStartUsd = nextTierStart
          nextBonus = levels[i + 1].bonusUsd[0] / 100 // Convert cents to dollars
          break
        }
      }
    }

    if (currentTierIndex === -1) {
      // If the current wager is below the first tier
      return { wagerLeft: nextTierStartUsd - currentWager, nextBonus }
    } else if (nextTierStartUsd > 0) {
      // If the current wager is between tiers
      return { wagerLeft: nextTierStartUsd - currentWager, nextBonus }
    } else {
      // If the current wager is within a tier
      const level = levels[currentTierIndex]
      const endUsd = level.tierStartUsd + level.tierStep * level.tierCount
      if (currentWager >= endUsd) {
        // If the current wager is at the final level of the current tier
        nextBonus = levels[currentTierIndex + 1].bonusUsd[0] / 100 // Convert cents to dollars
        return { wagerLeft: levels[currentTierIndex + 1].tierStartUsd - currentWager, nextBonus }
      }
      return { wagerLeft: nextLevelWager - currentWager, nextBonus }
    }
}